import {Membership} from './types';

export const MockData: Membership[] = [
  {
    id: 2,
    personId: 1,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 3,
    personId: 2,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 4,
    personId: 3,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 5,
    personId: 4,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 7,
    personId: 8,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 8,
    personId: 9,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 9,
    personId: 10,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 10,
    personId: 11,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 11,
    personId: 12,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 12,
    personId: 13,
    teamId: 20,
    employmentStart: '2021-02-08',
    monthlyHours: 160,
    weekdays: [1, 2, 3, 4, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
  {
    id: 13,
    personId: 13,
    teamId: 30,
    employmentStart: '2021-01-08',
    monthlyHours: 40,
    weekdays: [1, 5, 6, 7],
    maxDailyHours: 8,
    minDailyHours: 4,
    autoAssignShifts: true,
    vehicleTypeIds: [],
    weeks: [[true, true, true, true, true, true, true]],
    weeksStart: 'monday',
  },
];
